import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { async } from '@angular/core/testing';
import { HttpConfigService } from '../../http.config/http.config.service';
import { LoadingService } from '../../loading/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackDialogComponent } from 'src/app/components/feedback-dialog/feedback-dialog.component';
import { CanActivate, Router } from '@angular/router';

export class User{
  email: string;
  phone: string;
  gender: string;
  password: string;
  name: string;
  surname: string;
  picture: string;
  role: string;
}
@Injectable({
  providedIn: 'root'
})
export class UserService {
  user: User;
  constructor(
    private httpClient: HttpClient,
    private config: HttpConfigService,
    private ls: LoadingService,
    private router: Router,
    public dialog: MatDialog
    ) {
    if (localStorage.getItem('FSperson')) {
      this.user = JSON.parse(localStorage.getItem('FSperson')) as User;
    }
  }
  login(details: {email: string, password: string}) {
    this.ls.loading = true;
    console.log(details);
    const form = new FormData();
    form.append('email', details.email);
    form.append('password', details.password);
    const loginPost = this.httpClient.post<User>(`${this.config.apiPath}users/login.php`, form);
    loginPost.subscribe(userData => {
      this.user = userData;
      localStorage.setItem('FSperson', JSON.stringify(this.user));
      this.router.navigate(['/']);
    }, error => {
      this.openDialog('error', error.error.text);
      this.ls.loading = false;
    }, () => {
      this.ls.loading = false;
    });
  }
  register(details: {
    email: string,
    password: string,
    phone: string,
    surname: string,
    name: string,
                    }) {
    this.ls.loading = true;
    const form = new FormData();
    form.append('email', details.email);
    form.append('password', details.password);
    form.append('phone', details.phone);
    form.append('surname', details.surname);
    form.append('name', details.name);
    const loginPost = this.httpClient.post<{id: string, code: string}>(`${this.config.apiPath}users/register.php`, form);
    loginPost.subscribe(userData => {
      this.openDialog('success', `Registration Complete! an email has been sent to ${details.email} for confirmation`);
      console.log(userData);
    }, error => {
      this.ls.loading = false;
      this.router.navigate(['/login']);
      this.openDialog('error', error.error.text);
    }, () => {
      this.ls.loading = false;
    });
  }
  openDialog(mType: string, msg: string): void {
    const dialogRef = this.dialog.open(FeedbackDialogComponent, {
      data: {msgType: mType, message: msg}
    });
  }
  logout(){
    if (localStorage.getItem('FSperson')) {
      localStorage.removeItem('FSperson');
    }
    this.user = undefined;
  }
}
@Injectable({
  providedIn: 'root'
})
export class IsLoggedIn implements CanActivate{
  constructor(private us: UserService, private router: Router){}
  canActivate(){
    if (this.us.user === undefined || this.us.user === null){
      this.router.navigate(['/login']);
    }
    return this.us.user !== undefined && this.us.user !== null;
  }
}
@Injectable({
  providedIn: 'root'
})
export class IsLoggedOut implements CanActivate{
  constructor(private us: UserService, private router: Router){}
  canActivate(){
    if (this.us.user !== undefined && this.us.user !== null){
      this.router.navigate(['/']);
    }
    return this.us.user === undefined || this.us.user === null;
  }
}
